import React, { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Context as RegistrationAdminContext } from '../../../../providers/RegistrationAdminProvider';
import { useRegAssociationAdminPermissions } from '../../../../helpers/adminHelper';
import EvaluationSessionTableView from './EvaluationSessionTableView';
import EvaluationPlayersTable from './EvaluationPlayersTable';
import EvaluationTemplateTableView from './EvaluationTemplateTableView';
import EvaluationEvaluatorTableView from './EvaluationEvaluatorTableView';
import LoadableView from '../../../../components/common/LoadableView';

const EvaluationTableViews = () => {
  const { fetchRegScoutReportEvaluationOptions } = useContext(
    RegistrationAdminContext
  );
  const {
    regAssociation,
    isAssociationSuperAdmin
  } = useRegAssociationAdminPermissions();

  return (
    <LoadableView isLoading={!regAssociation}>
      <Routes>
        <Route element={<EvaluationSessionTableView />} path="/sessions" />

        {isAssociationSuperAdmin && (
          <>
            <Route
              element={<EvaluationTemplateTableView />}
              path="/templates"
            />
            <Route element={<EvaluationPlayersTable />} path="/players" />
            <Route
              element={<EvaluationEvaluatorTableView />}
              path="/evaluators"
            />
          </>
        )}

        <Route
          element={<Navigate replace to="/admin/evaluations/sessions" />}
          path="*"
        />
      </Routes>
    </LoadableView>
  );
};

export default EvaluationTableViews;
